import { render, staticRenderFns } from "./centralapoio.vue?vue&type=template&id=7f917dee"
import script from "./centralapoio.vue?vue&type=script&lang=js"
export * from "./centralapoio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports